import {QuickbetXCreateAction, QuickbetXCreateActionTypes, QuickbetXCreateState} from "../../types/QuickbetX/quickbetXCreateTypes";

const initialState: QuickbetXCreateState = {
    quickbetXCreateData: [],
    quickbetXCreateLoading: false,
    quickbetXCreatError: null,
};

export const quickbetXCreateReducer = (state = initialState, action: QuickbetXCreateAction): QuickbetXCreateState => {
    switch (action.type) {
        case QuickbetXCreateActionTypes.FETCH_QUICKBET_X_CREATE_DATA:
            return { ...state, quickbetXCreateLoading: true, quickbetXCreatError: null, quickbetXCreateData: [] };
        case QuickbetXCreateActionTypes.FETCH_QUICKBET_X_CREATE_DATA_SUCCESS:
            return { ...state, quickbetXCreateLoading: false, quickbetXCreatError: null, quickbetXCreateData: action.payload };
        case QuickbetXCreateActionTypes.FETCH_QUICKBET_X_CREATE_DATA_ERROR:
            return { ...state, quickbetXCreateLoading: false, quickbetXCreatError: action.payload, quickbetXCreateData: [] };
        default:
            return state;
    }
};
